import React from "react";
import { Button } from "js/Components/Button";
import styled from "styled-components";
import { getStaticUrl } from "js/config";
import UpgradeIcon from "js/Components/UpgradeIcon";
import { themeColors } from "js/react/sharedStyles";
import { FlexBox } from "js/react/components/LayoutGrid";
import Warning from "@mui/icons-material/WarningRounded";

interface BannerContainerProps {
    buttonLabel?: string;
    onButtonClick?: () => void;
    headerText?: string;
    bodyText?: string;
    showIcon?: boolean;
    iconType?: string;
    className?: string;
}

const BannerContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    justify-content: space-between;
    padding: 15px 20px;
    background: #FFF0E3;
    border-radius: 2px;
    gap: 5px;
    user-select: none;
    border: 1px solid #FA0;
`;

const BannerHeader = styled.div`
    color: #333;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
`;

const BannerBody = styled.div`
    color: ${themeColors.mediumGray};
    font-family: "Source Sans Pro";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
`;

const IconWrapper = styled.div`
    margin-right: 12px; 
    align-self: flex-start; 
`;

export default function Banner({ buttonLabel, headerText, bodyText, onButtonClick, iconType, className }: BannerContainerProps) {
    const renderIcon = () => {
        if (iconType === "warning") {
            return <Warning style={{ color: "#FA901F", fontSize: 18, verticalAlign: "middle" }} />;
        }
        return null;
    };

    const icon = renderIcon();

    return (
        <BannerContainer className={className}>
            <FlexBox left>
                {icon && (
                    <IconWrapper>
                        {icon}
                    </IconWrapper>
                )}
                <FlexBox column left>
                    <BannerHeader>{headerText}</BannerHeader>
                    <BannerBody>{bodyText}</BannerBody>
                </FlexBox>
            </FlexBox>
            {buttonLabel && onButtonClick && (
                <div style={{ flexShrink: 0 }}>
                    <Button upgrade onClick={onButtonClick}>
                        <UpgradeIcon />
                        {buttonLabel}
                    </Button>
                </div>
            )}
        </BannerContainer>
    );
}
